import React, {Component} from 'react';
import { Modal, List, Button, WingBlank, InputItem, Picker, Toast, NoticeBar } from 'antd-mobile';
import Blank from '../components/Blank';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import TipPlaceholder from '../components/TipPlaceholder';
import HeaderView from '../components/HeaderView';
import ProfileView from '../components/ProfileView';
import RechargeView from '../components/RechargeView';
import PacketView from '../components/PacketView';
import DataFetcher from '../utils/DataFetcher';
import CommonUtils from '../utils/CommonUtils';
import BrandUtils from '../utils/BrandUtils';
import Constants from '../utils/Constants';
import { createForm } from 'rc-form';
import '../styles/Recharge.css';

const alert = Modal.alert

class Recharge extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status: 'loading',
            userProfile: {},
            deviceInfo: {},
            rechargeRules: [],
            packetRules: [],
            sites: [],
            bindModalVisible: false,
            enableRecharge: true,
            enableBuyPacket: true,
            enableContinuing: true,
            enableBindDevice: true,
            account: null,
            brandInfo: null,
            deviceTypes: [],
            virtualPlayer: null,
            useVirtualPlayer: false
        }
    }

    componentDidMount() {
        this.code = CommonUtils.resolveSearchParam(this.props.location, 'code')
        this.deviceId = CommonUtils.resolveSearchParam(this.props.location, 'state')
        if(CommonUtils.isEmpty(this.deviceId)) {
            Toast.fail('无法识别设备ID')
            this.setState({
                status: 'noauth'
            })
            return
        }

        if(this.code) {
            this.login()
        } else {
            this.setState({
                status: 'success'
            })
            this.loadInitData()
        }
    }

    login = () => {
        DataFetcher.login({
            code: this.code
        }, {
            success: (resp) => {
                this.setState({
                    status: 'success'
                })
                this.loadInitData()
            },
            logicError: () => {
                this.setState({
                    status: 'noauth'
                })
            },
            sysError: () => {
                this.setState({
                    status: 'noauth'
                })
            }
        });
    }

    loadInitData = () => {
        this.loadDeviceTypes()
        this.loadBranInfo()
        this.loadProfile()
        this.loadDeviceInfo()
        this.loadRechargeRules()
        this.loadPacketRules()
        this.loadVirtualPlayer()
    }

    loadDeviceTypes = () => {
        DataFetcher.deviceTypes({}, {
            success: (resp) => {
                this.setState({
                    deviceTypes: resp.data
                })
            }
        })
    }

    loadBranInfo = () => {
        DataFetcher.brandInfo({
            deviceId: this.deviceId
        }, {
            success: (resp) => {
                this.setState({
                    brandInfo: resp.data
                }, () => {
                    BrandUtils.refreshPageBrand(this.state.brandInfo)
                })
            }
        })
    }

    loadProfile = () => {
        DataFetcher.profile({
            deviceId: this.deviceId
        }, { 
            success: (resp) => {
                let accountPickerData = this.doGenerateAccountPickerData(resp.data)
                this.setState({
                    userProfile: resp.data,
                    account: accountPickerData&&accountPickerData.length ? accountPickerData[0].value : null
                }, () => {
                    this.loadSites()
                })
            }
        })
    }

    loadSites = () => {
        const { account } = this.state
        const accountInfo = this.doResolveAccountInfo(account)
        
        if(accountInfo.type === 'agent') {
            DataFetcher.agentSites((resp) => {
                this.setState({
                    sites: resp.data
                })
            })
        } else if(accountInfo.type === 'delegate') {
            DataFetcher.delegateSites({
                delegateId: accountInfo.id
            }, {
                success: (resp) => {
                    this.setState({
                        sites: resp.data
                    })
                }
            })
        }
    }

    loadDeviceInfo = () => {
        if(!this.deviceId) return
        DataFetcher.deviceInfo(this.deviceId, (resp) => {
            this.setState({
                deviceInfo: resp.data
            })
        })
    }

    loadPacketRules = () => {
        DataFetcher.packetRules({
            deviceId: this.deviceId
        },{
            success: (resp) => {
                this.setState({
                    packetRules: resp.data
                })
            }
        })
    }

    loadRechargeRules = () => {
        DataFetcher.rechargeRules({
            deviceId: this.deviceId
        }, (resp) => {
            this.setState({
                rechargeRules: resp.data
            })
        })
    }

    loadVirtualPlayer = () => {
        DataFetcher.virtualPlayer({
            deviceId: this.deviceId
        }, { 
            success: (resp) => {
                this.setState({
                    virtualPlayer: resp.data
                })
            }
        })
    }

    onAccountPickerChange = (val) => {
        this.setState({
            account: val[0]
        }, () => {
            this.loadSites()
        })
    }

    doResolveAccountInfo = (account) => {
        if(!account) return {}

        let items = account.split('-')
        if(items.length !== 2) return {}

        return {
            type: items[0],
            id: items[1]
        }
    }

    doGenerateAccountPickerData = (userProfile) => {
        let accountPickerData = []
        if(!userProfile) return accountPickerData

        if(userProfile.agentId) {
            accountPickerData.push({ value: `agent-${userProfile.agentId}`, label: userProfile.agentName})
        }
        if(userProfile.delegates && userProfile.delegates.length) {
            for(let delegate of userProfile.delegates) {
                if(delegate.delegateType === 'OPERATOR') {
                    accountPickerData.push({value: `delegate-${delegate.id}`, label: `${delegate.agentName}(${delegate.delegateName})`})
                }
            }
        }
        return accountPickerData
    }

    formatGameMinutes = (gameMinutes) => {
        if(!gameMinutes) {
            return '0'
        }

        // eslint-disable-next-line
        let hours = parseInt(gameMinutes / 60)
        let minutes = gameMinutes % 60
        if(!hours) {
            return `${minutes}分钟`
        }

        return `${hours}小时${minutes}分`
    }

    calculateRuleUnitPrice = (rule) => {
        const { fresher } = this.state;
        if(fresher && rule.fresherPrice) {
            let unitPrice = rule.fresherPrice/rule.gameMinutes
            return unitPrice.toFixed(2)
        }

        let unitPrice = rule.price/rule.gameMinutes
        return unitPrice.toFixed(2)
    }

    handleContinuing = () => {
        const { useVirtualPlayer, virtualPlayer } = this.state

        this.setState({
            enableContinuing: false
        })
        DataFetcher.loginDevice({
            deviceId: this.deviceId,
            virtualUserId: useVirtualPlayer&&virtualPlayer&&virtualPlayer.virtualUserId ? virtualPlayer.virtualUserId : null
        }, (resp) => {
            Toast.info('设备启动中！若无响应，可使用其它设备！', 5)
        }, () => {
            this.setState({
                enableContinuing: true
            })
        })
    }

    canPayUsingBalance = (packetRule) => {
        const { userProfile } = this.state
        if(!packetRule || !userProfile || !userProfile.balance || userProfile.balance <= 0) {
            return false
        }

        if(userProfile.fresher && packetRule.fresherPrice && packetRule.fresherPrice > 0) {
            if(userProfile.balance >= packetRule.fresherPrice) {
                return true
            } else {
                return false
            }
        }

        return userProfile.balance >= packetRule.price
    }

    calExchangeGameMinutes = () => {
        const { userProfile, packetRules } = this.state
        if(!userProfile || !userProfile.balance || userProfile.balance <= 0) {
            return 0
        }

        if(!packetRules || !packetRules.length) {
            return 0
        }

        let targetGameMinutes = 0
        let targetPrice = 0
        for(let rule of packetRules) {
            if(targetPrice <= 0 || rule.price < targetPrice) {
                targetGameMinutes = rule.gameMinutes
                targetPrice = rule.price
            }
        }

        if(targetPrice <= 0) {
            return 0
        }

        let gameMinutes = Math.ceil(userProfile.balance/targetPrice*targetGameMinutes)
        if(gameMinutes <= 0) {
            gameMinutes = 1
        }
        return gameMinutes
    }

    handleBuyPacket = (packetRule) => {
        const { enableBuyPacket, useVirtualPlayer, virtualPlayer } = this.state
        if(!enableBuyPacket) {
            Toast.info('购买中')
            return
        }

        if(!useVirtualPlayer && virtualPlayer && virtualPlayer.available) {
            alert('退出“其它设备”？', '您登录过其它设备', [
                { text: '否', onPress: () => {
                    this.setState({
                        useVirtualPlayer: true
                    }, () => {
                        this.doChooseBuyPacketWay(packetRule)
                    })
                }},
                { text: '是', onPress: () => {
                    this.doChooseBuyPacketWay(packetRule)
                }},
              ]
            )
            return
        }

        this.doChooseBuyPacketWay(packetRule)
    }

    handleChooseStartDeviceWay = () => {
        alert('退出“其它设备”？', '您登录过其它设备', [
            { text: '否', onPress: () => {
                this.setState({
                    useVirtualPlayer: true
                })
            }},
            { text: '是', onPress: () => {
                this.handleContinuing()
            }},
          ]
        )
    }

    doChooseBuyPacketWay = (packetRule) => {
        const { useVirtualPlayer } = this.state

        if(this.canPayUsingBalance(packetRule)) {
            alert('确认要使用余额付款?', packetRule.name, [
                { text: '取消', onPress: () => {} },
                { text: '确认', onPress: () => {
                    if(useVirtualPlayer) {
                        this.doBuyVirtualPacket(packetRule)
                    } else {
                        this.doBuyPacket(packetRule)
                    }
                }},
              ]
            )
            return
        }
        
        let exchangeGameMinutes = this.calExchangeGameMinutes()
        if(exchangeGameMinutes > 0) {
            if(!useVirtualPlayer) {
                alert(`使用余额兑换时间?`, `${exchangeGameMinutes} 分钟`, [
                    { text: '取消', onPress: () => {
                        this.doBuyPacket(packetRule)
                    }},
                    { text: '确认', onPress: () => {
                        this.doExchangeBalance()
                    }},
                ]) 
                return
            }
        }

        if(useVirtualPlayer) {
            this.doBuyVirtualPacket(packetRule)
        } else {
            this.doBuyPacket(packetRule)
        }
    }

    doBuyPacket = (packetRule) => {
        let self = this
        this.setState({
            enableBuyPacket: false
        })
        Toast.info('支付跳转中')
        DataFetcher.buyPacket(
            {
                gamePacket: packetRule.id,
                deviceId: this.deviceId
            }, 
            (resp) => {
                CommonUtils.invokeWechatPay(resp.data, () => {
                    Toast.info('设备启动中！若无响应，可使用其它设备！', 5)
                    self.loadInitData()
                })
            },
            () => {
                this.setState({
                    enableBuyPacket: true
                })
            }
        )
    }

    doBuyVirtualPacket = (packetRule) => {
        const { virtualPlayer } = this.state
        let self = this
        this.setState({
            enableBuyPacket: false
        })
        Toast.info('支付跳转中')
        DataFetcher.buyVirtualPacket(
            {
                gamePacket: packetRule.id,
                deviceId: this.deviceId,
                virtualUserId: virtualPlayer ? virtualPlayer.virtualUserId : null
            }, 
            {
                success: (resp) => {
                    CommonUtils.invokeWechatPay(resp.data, () => {
                        Toast.info('设备启动中！若无响应，可使用其它设备！', 5)
                        self.loadInitData()
                    })
                },
                completed: () => {
                    this.setState({
                        enableBuyPacket: true
                    })
                }
            }
        )
    }

    doExchangeBalance = () => {
        let self = this
        this.setState({
            enableBuyPacket: false
        })
        Toast.info('兑换跳转中')
        DataFetcher.exchageBalance(
            {
                deviceId: this.deviceId
            }, {
                success: (resp) => {
                    Toast.info('设备启动中！若无响应，可使用其它设备！', 5)
                    self.loadInitData()
                },
                completed: () => {
                    this.setState({
                        enableBuyPacket: true
                    })
                }
            }
        )
    }

    handleRecharge = (rechargeRule) => {
        if(!this.state.enableRecharge) {
            Toast.info('充值中')
            return
        }

        let self = this
        this.setState({
            enableRecharge: false
        })
        Toast.info('支付跳转中')
        DataFetcher.recharge({
            rechargeRule,
            deviceId: this.deviceId
        }, (resp) => {
            CommonUtils.invokeWechatPay(resp.data, () => {
                Toast.info('充值成功，去购买游戏套餐吧！')
                setTimeout(() => {
                    self.loadInitData()
                }, 2000)
            })
        }, () => {
            this.setState({
                enableRecharge: true
            })
        })

    }

    handleBindDevice = () => {
        const { account } = this.state
        let accountInfo = this.doResolveAccountInfo(account)

        this.setState({
            enableBindDevice: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            if(error) {
                for(let prop in error) {
                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableBindDevice: true
                        })
                        return
                    }
                }
            }

            let params = { ...fieldsValue }
            params.siteId = params.siteId[0]

            if(accountInfo.type === 'agent') {
                DataFetcher.bindDevice(params, (resp) => {
                    this.setState({
                        bindModalVisible: false
                    })
                    Toast.info('设备绑定成功')
                    this.loadInitData()
                }, () => {
                    this.setState({
                        enableBindDevice: true
                    })
                })
            } else if(accountInfo.type === 'delegate') {
                params.delegateId = accountInfo.id
                DataFetcher.delegateBindDevice(params, (resp) => {
                    this.setState({
                        bindModalVisible: false
                    })
                    Toast.info('设备绑定成功')
                    this.loadInitData()
                }, () => {
                    this.setState({
                        enableBindDevice: true
                    })
                })
            } else {
                this.setState({
                    enableBindDevice: true
                })
            }
        });
    }

    generateHeaderView() {
        const { userProfile, enableContinuing, brandInfo, virtualPlayer, useVirtualPlayer } = this.state;

        let data = {
            deviceId: this.deviceId,
            avatar: userProfile.avatar,
            nickName: userProfile.nickName,
            gameMinutes: userProfile.gameMinutes,
            enableContinuing,
            description: brandInfo&&CommonUtils.isNotEmpty(brandInfo.slogan)?brandInfo.slogan:Constants.Strings.APP_NAME
        }
        let continuingFunc = this.handleContinuing
        if(virtualPlayer && virtualPlayer.available) {
            data.continuingText = '启动设备'
            continuingFunc = this.handleChooseStartDeviceWay
        }
        if(useVirtualPlayer) {
            data.continuingText = null
            data.gameMinutes = virtualPlayer && virtualPlayer.gameMinutes ? virtualPlayer.gameMinutes : 0
            continuingFunc = this.handleContinuing
        }

        return <HeaderView handleContinuing={continuingFunc} data={data}/>
    }

    generateProfileView() {
        const { userProfile, virtualPlayer, useVirtualPlayer } = this.state;
        let data = []
        let gameMinutes = useVirtualPlayer&&virtualPlayer ? virtualPlayer.gameMinutes : userProfile.gameMinutes
        data.push({label: '剩余时间', value: CommonUtils.readableGameMinutes(gameMinutes)})
        data.push({label: '账户余额', value: userProfile.balance})
        data.push({label: '游戏积分', value: userProfile.point})
        return <ProfileView data={data}/>
    }

    generateBindView() {
        const { userProfile, deviceInfo } = this.state
        if(!deviceInfo.deviceId || deviceInfo.agentId) {
            return
        }

        let accountPickerData = this.doGenerateAccountPickerData(userProfile)
        if(!accountPickerData || !accountPickerData.length) {
            return
        }

        return (
            <div className='section-bind'>
                <div className="title word-ellipsis">
                    <span className='main'><i className='iconfont icon-diannao'></i> 绑定设备</span>
                    <span className='sub'></span>
                </div>
                <div className='wrapper-bind-info'>
                    <div className='operation'>
                        <button onClick={() => {this.setState({bindModalVisible: true})}}>开始绑定</button>
                    </div>
                </div>
            </div>
        )
    }

    generateBindModal = () => {
        const { getFieldProps } = this.props.form;
        const { userProfile, deviceInfo, bindModalVisible, sites, enableBindDevice } = this.state
        if(!deviceInfo.deviceId || deviceInfo.agentId) {
            return
        }

        let accountPickerData = this.doGenerateAccountPickerData(userProfile)
        if(!accountPickerData || !accountPickerData.length) {
            return
        }

        let sitePickerData = sites.map(item => ({value: item.id, label: item.siteName}))
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={bindModalVisible}
                    onClose={() => {this.setState({bindModalVisible: false})}}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List renderHeader={() => <div style={{fontWeight: 'bold', fontSize:'17px', color: '#222222'}}>绑定设备</div>} className="popup-list">
                        <InputItem {...getFieldProps('deviceId', {initialValue: deviceInfo.deviceId})} disabled>
                            设备ID
                        </InputItem>
                        <InputItem {...getFieldProps('deviceName', {
                            initialValue: deviceInfo.deviceName,
                            rules: [{required: true, message: '请填写设备名'}],
                        })}>
                            设备名
                        </InputItem>
                        <Picker 
                            cols={1} 
                            {...getFieldProps('account', {
                                initialValue: [accountPickerData[0].value],
                                rules: [{required: true, message: '请选择代理'}],
                            })} 
                            onOk={this.onAccountPickerChange}
                            data={accountPickerData}>
                            <List.Item arrow="horizontal">代&nbsp;&nbsp;&nbsp;理</List.Item>
                        </Picker>
                        <Picker 
                            cols={1} 
                            {...getFieldProps('siteId', {
                                initialValue: sites&&sites.length?[sites[0].id]:[],
                                rules: [{required: true, message: '请选择门店'}],
                            })} 
                            data={sitePickerData}>
                            <List.Item arrow="horizontal">门&nbsp;&nbsp;&nbsp;店</List.Item>
                        </Picker>
                        <List.Item>
                            <Button type="primary" onClick={this.handleBindDevice} disabled={!enableBindDevice}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    generateRechargeView() {
        const { rechargeRules, deviceInfo } = this.state
        if(!rechargeRules || !rechargeRules.length || !deviceInfo || deviceInfo.hideRecharge) {
            return
        }

        return <RechargeView handleRecharge={this.handleRecharge} data={rechargeRules}/>
    }

    generatePacketView() {
        const {packetRules, userProfile} = this.state;

        let data = {
            fresher: userProfile.fresher,
            rules: packetRules
        }
        
        return <PacketView handleBuyPacket={this.handleBuyPacket} data={data}/>
    }

    generateDeviceView() {
        const { deviceInfo, userProfile } = this.state
        if(!deviceInfo || !deviceInfo.deviceId) {
            return
        }

        let deviceName = CommonUtils.isEmpty(deviceInfo.deviceName) ? deviceInfo.deviceId : deviceInfo.deviceName
        if(userProfile && userProfile.latestConsumedDeviceType) {
            deviceName += `  ${CommonUtils.resolveDictText(userProfile.latestConsumedDeviceType, this.state.deviceTypes, 'code', 'name')}`
        }

        return (
            <div className='section-device'>
                <div className='name word-ellipsis'>
                    <i className='iconfont icon-diannao'></i>
                    &nbsp;&nbsp;
                    <span>{deviceName}</span>
                </div>
            </div>
        )
    }

    generateNoticeView() {
        const { userProfile } = this.state;

        if(userProfile && userProfile.nickName === '微信用户') {
            return <NoticeBar marqueeProps={{ loop: true, style: { padding: '0 7.5px' } }}>如果网页无响应，请点击右下方 “使用完整服务”</NoticeBar>
        }
    }

    generateVirtualPlayerNotice() {
        const { useVirtualPlayer } = this.state;

        if(useVirtualPlayer) {
            return <NoticeBar marqueeProps={{ loop: true, style: { padding: '0 7.5px' } }}>其它设备已保留，请购买“游戏套餐”启动新设备！</NoticeBar>
        }
    }

    generateQRCodeView = () => {
        const { brandInfo } = this.state
        if(!brandInfo || CommonUtils.isEmpty(brandInfo.wxmpQrCode)) {
            return
        }

        return (
            <div className='section-qrcode'>
                <div className='qrcode-content'>
                    <img src={brandInfo.wxmpQrCode} alt=""/>
                </div>
                <div className='qrcode-tip'>获取游戏资讯及优惠</div>
            </div>
        )
    }

    doRenderView() {
        return (
            <div className="page-recharge">
                {this.generateNoticeView()}
                {this.generateVirtualPlayerNotice()}
                {this.generateHeaderView()}
                <Blank/>
                {this.generateProfileView()}
                <Blank/>
                {this.generateBindView()}
                {this.generateRechargeView()}
                {this.generatePacketView()}
                {this.generateDeviceView()}
                {this.generateQRCodeView()}
                {this.generateBindModal()}
            </div>
        )
    }

    render() {
        const {status} = this.state;

        if(status === 'loading') {
            return <LoadingPlaceholder/>;
        } else if (status === 'noauth') {
            return <TipPlaceholder firstTip={'请重新扫码'}/>;
        } else {
            return this.doRenderView()
        }
    }
}

export default createForm()(Recharge);


// WEBPACK FOOTER //
// ./src/modules/Recharge.js